/*=========================================================================================
  File Name: moduleCompanyActions.js
  Description: Company Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    updateDashboardCompany({ commit }, payload) {
      new Promise ((resolve, reject) => {
        commit('UPDATE_DASHBOARD_COMPANY', payload)
        resolve()
      })
    },

    updateCompanyWallet({ commit }, payload) {
      new Promise ((resolve, reject) => {
        commit('UPDATE_COMPANY_WALLET', payload)
        resolve()
      })
    },
}
